const STREAM_URL = '/api/events/stream';
const RECONNECT_DELAYS_MS = [1000, 2000, 5000, 10000, 20000, 30000];

function canUseEventSource() {
  return typeof window !== 'undefined' && typeof window.EventSource !== 'undefined';
}

function isRealtimePushEnabled() {
  if (typeof window === 'undefined') return false;

  // SSE keeps a Vercel Function open for the whole browser session. Keep it
  // available for local development and explicit production opt-in only.
  if (window.TRIA_ENABLE_REALTIME_SSE === true) return true;
  if (window.localStorage?.getItem('tria-enable-realtime-sse') === '1') return true;

  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

class RealtimePushManager {
  constructor({ onDataChange } = {}) {
    this.onDataChange = onDataChange;
    this.eventSource = null;
    this.started = false;
    this.retryTimer = null;
    this.retryIndex = 0;
  }

  start() {
    if (this.started || !canUseEventSource() || !isRealtimePushEnabled()) return;
    this.started = true;
    this.connect();
  }

  stop() {
    this.started = false;
    if (this.retryTimer) {
      clearTimeout(this.retryTimer);
      this.retryTimer = null;
    }
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  }

  connect() {
    if (!this.started) return;
    if (!window.__appReady) {
      if (!this.retryTimer) {
        this.retryTimer = setTimeout(() => {
          this.retryTimer = null;
          this.connect();
        }, 2000);
      }
      return;
    }

    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }

    const source = new EventSource(STREAM_URL, { withCredentials: true });
    this.eventSource = source;

    source.addEventListener('ready', () => {
      this.retryIndex = 0;
    });

    source.addEventListener('data-change', (evt) => {
      try {
        const payload = JSON.parse(evt.data);
        if (typeof this.onDataChange === 'function') {
          this.onDataChange(payload);
        }
      } catch (err) {
        console.warn('[realtime-push] Neplatný payload data-change:', err);
      }
    });

    source.onerror = () => {
      this.scheduleReconnect();
    };
  }

  scheduleReconnect() {
    if (!this.started) return;
    if (this.retryTimer) return;

    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }

    const delay = RECONNECT_DELAYS_MS[Math.min(this.retryIndex, RECONNECT_DELAYS_MS.length - 1)];
    this.retryIndex += 1;
    this.retryTimer = setTimeout(() => {
      this.retryTimer = null;
      this.connect();
    }, delay);
  }
}

export function initRealtimePush(options = {}) {
  const manager = new RealtimePushManager(options);
  manager.start();
  return manager;
}
